import { useCallback } from 'react';
import { useNotificationMessage } from 'src/common/notification/message.hook';
import { generateJourneyAliasShareUrl } from 'src/utils/journey';
import { useCurrentOrganization } from 'src/store/organization';
import { JourneyAlias } from 'src/common/interfaces/journey/alias.interface';

import { Node } from 'src/common/interfaces/node.interface';
import { useClipboard } from 'src/utils/use-clipboard.hook';

export const useJourneyAliasUrlClipboardCopy = ({
  successNotificationMessage,
  onCopySuccess,
}: {
  successNotificationMessage: string;
  onCopySuccess?: () => void;
}) => {
  const { currentOrganization } = useCurrentOrganization();
  const { setSuccessNotification } = useNotificationMessage();

  const onCopy = useCallback(() => {
    successNotificationMessage && setSuccessNotification(successNotificationMessage);
    onCopySuccess && onCopySuccess();
  }, [successNotificationMessage, setSuccessNotification, onCopySuccess]);

  const { copyToClipboard } = useClipboard({ onCopy });

  const copyAliasUrlToClipboard = useCallback(
    (alias: JourneyAlias) => {
      copyToClipboard(generateJourneyAliasShareUrl(currentOrganization, alias.slug));
    },
    [currentOrganization, copyToClipboard]
  );

  const copyNodeUrlToClipboard = useCallback(
    (alias: JourneyAlias, node: Node) => {
      copyToClipboard(generateJourneyAliasShareUrl(currentOrganization, alias.slug, node.friendly_path));
    },
    [currentOrganization, copyToClipboard]
  );

  return { copyAliasUrlToClipboard, copyNodeUrlToClipboard };
};
